import { render, staticRenderFns } from "./EmptyListImageDocuments.vue?vue&type=template&id=be804b32&scoped=true"
var script = {}
import style0 from "./EmptyListImageDocuments.vue?vue&type=style&index=0&id=be804b32&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be804b32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be804b32')) {
      api.createRecord('be804b32', component.options)
    } else {
      api.reload('be804b32', component.options)
    }
    module.hot.accept("./EmptyListImageDocuments.vue?vue&type=template&id=be804b32&scoped=true", function () {
      api.rerender('be804b32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/emptyListImages/EmptyListImageDocuments.vue"
export default component.exports